import { ObjectMeta, Time } from 'proto/github.com/solo-io/dev-portal/api/grpc/common/common_pb';
import {APIType, APITypeMap} from "proto/github.com/solo-io/dev-portal/api/dev-portal/v1beta1/apiproduct_pb";

export function copyTextToClipboard(copyText: string): boolean {
  let textArea = document.createElement('textarea');

  textArea.style.position = 'fixed';
  textArea.style.top = '-999px';
  textArea.style.left = '-999px';

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em';
  textArea.style.height = '2em';

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'rgba(255, 255, 255, 0)';

  textArea.value = copyText;

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {}

  document.body.removeChild(textArea);

  return success;
}

export const formatUnit = (usagePlanUnit: string) => {
  switch (usagePlanUnit) {
    case 'MINUTES':
      return 'minute';
    case 'HOURS':
      return 'hour';
    case 'DAYS':
      return 'day';
    case 'SECONDS':
      return 'second';
    default:
      return '';
  }
};

export const formatDate = (date: Time.AsObject): string => {
  if (!date) {
    return 'Unknown';
  } else {
    const d = new Date(1000*date.seconds);
    return d.toUTCString();
  }
};

export const getAPITypeName = (apiType: APITypeMap[keyof APITypeMap]) => {
  switch (apiType) {
    case APIType.OPEN_API: {
      return 'OpenAPI';
    }
    case APIType.GRPC: {
      return 'gRPC';
    }
    case APIType.HYBRID: {
      return 'HYBRID';
    }
    case APIType.EMPTY:
    default: {
      return 'EMPTY';
    }
  }
};

export const getRefFromId = (id: string) => {
  let [namespace, name] = id.split('_');
  return { name, namespace };
};

export const getIdFromMetadata = (metadata: ObjectMeta.AsObject) => {
  let { namespace, name } = metadata;
  return `${namespace}_${name}`;
};

export const sortByName = <T extends { name: string }>(a: T, b: T) =>
  a.name === b.name ? 0 : a.name > b.name ? 1 : -1;

export const sortByDisplayName = (a: { displayName: string }, b: { displayName: string }) =>
  a.displayName === b.displayName ? 0 : a.displayName > b.displayName ? 1 : -1;

export const sortByMetaName = (a: { metadata?: { name: string } }, b: { metadata?: { name: string } }) => {
  if (!a.metadata) {
    return -1;
  }

  if (!b.metadata) {
    return 1;
  }

  return a.metadata.name === b.metadata.name ? 0 : a.metadata.name > b.metadata.name ? 1 : -1;
};
